import axios from 'axios';
import debug from 'debug';

const log = debug('app:GsmpiApiForStageTest');

const gsmpiApi = axios.create({
  timeout: 15000,
});

export const createTestTransaction = async (createTransactionRequest) => {
  try {
    return await gsmpiApi.post('/gsmpi-api/v1/test-transactions', createTransactionRequest);
  } catch (error) {
    log(`createTransaction error: ${error}`);
    throw error;
  }
};

export const fetchPayableCards = async ({transactionId: transactionId}) => {
  try {
    return await gsmpiApi.get(`/gsmpi-api/v1/test-transactions/${transactionId}/cards`);
  } catch (error) {
    log(`fetchPayableCards error: ${error}`);
    throw error;
  }
};

export const fetchDummyPaymentCredentials = async ({transactionId: transactionId, cardId: cardId, serviceId: serviceId}) => {
  try {
    return await gsmpiApi.get(`/gsmpi-api/v1/test-transactions/${transactionId}/cards/${cardId}/credentials`, {
      params: {
        serviceId: serviceId
      }
    });
  } catch (error) {
    log(`fetchDummyPaymentCredentials error: ${error}`);
    throw error;
  }
};